module.exports = __webpack_public_path__ + "img/disney_logo.e150d36a.png";